import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=045d2905&"
import script from "./Stamp.vue?vue&type=script&lang=js&"
export * from "./Stamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports